/* eslint-disable no-unused-vars */
import { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Box, Card, CardContent, Divider, Link, Typography, Grid } from '@material-ui/core';
import {
  LoginAmplify,
  LoginAuth0,
  LoginFirebase,
  LoginJWT
} from '../../components/authentication/login';
import Logo from '../../components/Logo';
import useAuth from '../../hooks/useAuth';
import gtm from '../../lib/gtm';
import useSettings from '../../hooks/useSettings';
import LogoBlanc from '../../components/LogoBlanc';

const Login = () => {
  const { platform } = useAuth();
  const { settings } = useSettings();
  const { hostname } = window.location;
  const tenant = hostname.split('.')[0].toUpperCase();

  useEffect(() => {
    gtm.push({ event: 'page_view' });
  }, []);

  return (
    <>
      <Helmet>
        <title>Syndays {tenant} | Connexion</title>
      </Helmet>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          height: '100vh', // Full height
          width: '100vw',  // Full width
        }}
      >
        {/* Left Section */}
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: 4,
            backgroundColor: settings.theme === 'LIGHT' ? 'background.default' : 'background.paper',
          }}
        >
          {settings.theme === 'LIGHT' && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                mb: 8
              }}
            >
              <RouterLink to="/">
                <Logo
                  sx={{
                    height: 100,
                    width: 350
                  }}
                />
              </RouterLink>
            </Box>
          )}
          {settings.theme === 'DARK' && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                mb: 8
              }}
            >
              <RouterLink to="/">
                <LogoBlanc
                  sx={{
                    height: 100,
                    width: 350
                  }}
                />
              </RouterLink>
            </Box>
          )}
          <Card
            sx={{
              width: '100%',
              maxWidth: 500,
            }}
          >
            <CardContent
              sx={{
                display: 'flex',
                flexDirection: 'column',
                p: 4
              }}
            >
              <Box
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'space-between',
                  mb: 3
                }}
              >
                <div>
                  <Typography
                    color="textPrimary"
                    gutterBottom
                    variant="h4"
                  >
                    Connexion
                  </Typography>
                  <Typography
                    color="textSecondary"
                    variant="body2"
                  >
                    Utilisez votre compte Syndays {tenant}
                  </Typography>
                </div>
              </Box>
              <Box
                sx={{
                  flexGrow: 1,
                  mt: 3
                }}
              >
                {platform === 'Amplify' && <LoginAmplify />}
                {platform === 'Auth0' && <LoginAuth0 />}
                {platform === 'Firebase' && <LoginFirebase />}
                {platform === 'JWT' && <LoginJWT />}
              </Box>
              <Divider sx={{ my: 3 }} />
              <Link
                color="textSecondary"
                component={RouterLink}
                to="../password-recovery"
                variant="body2"
              >
                Mot de passe oublié ?
              </Link>
              {platform === 'Amplify' && (
                <Link
                  color="textSecondary"
                  component={RouterLink}
                  sx={{ mt: 1 }}
                  to="./pages/Contact"
                  variant="body2"
                >
                  Mot de passe oublié ?
                </Link>
              )}
            </CardContent>
          </Card>
        </Box>

        {/* Right Section */}
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            position: 'relative', // Nécessaire pour positionner l'image
            overflow: 'hidden',
          }}
        >
          {/* Replace with your image */}
          <img
            src="pexels-olly-840996.jpg"
            alt="Illustration"
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'cover',
            }}
          />
        </Box>
      </Box>
    </>
  );
};

export default Login;
